export const SUB_CAT_HORIZONTAL_MODAL_ID = 'sub-cat-horizontal-modal';
